import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { SettingsContentPanel } from 'app/components/common/SettingsContentPanel';
import { Button, Checkbox } from 'antd';

export const DEFAULT_MONITORED_EVENTS_SETTINGS = {
    activeOnly: true,
};

export interface MonitoredEventsSettings {
    activeOnly: boolean;
}

export class MonitoredEventsSettingsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>EVENTS SETTINGS</div>
            </Flex>
        );
    }
}

export class MonitoredEventsSettingsContent extends SettingsContentPanel<MonitoredEventsSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '20em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.activeOnly}
                        onChange={value => this.setState({ activeOnly: value.target.checked })}>
                        Active only
                    </Checkbox>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}
